'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QueueAnim = require('./QueueAnim');

var _QueueAnim2 = _interopRequireDefault(_QueueAnim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _QueueAnim2["default"]; // export this package's api

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-queue-anim/lib/index.js
 ** module id = 437
 ** module chunks = 0
 **/